import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "website-importer-shape1",
  "use": "website-importer-shape1-usage",
  "viewBox": "0 0 231 97",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 231 97\" id=\"website-importer-shape1\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M36.321 301.742c70.739 5.365 149.198-12.246 176.043-77.982 28.103-68.818-6.789-146.147-66.423-190.451C93.651-5.54 24.073 7.74-30.485 43.339c-53.848 35.133-94.263 93.793-78.161 156.078 16.379 63.351 79.781 97.382 144.967 102.325z\" fill=\"#AB80DE\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol